import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-download-ios-dialog',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './download-ios-dialog.component.html',
  styleUrl: './download-ios-dialog.component.scss',
})
export class DownloadIosDialogComponent {
  readonly appStoreUrl = 'https://apps.apple.com/us/app/j-j-medtech-ai-advisor/id6756101233';

  constructor(public dialogRef: MatDialogRef<DownloadIosDialogComponent>) { }

  close(): void {
    this.dialogRef.close();
  }

  openAppStore(): void {
    window.open(this.appStoreUrl, '_blank', 'noopener,noreferrer');
  }
}
